export default "__VITE_ASSET__Cbpk_10S__"